/*
 * @Author: cchps neohua87@gmail.com
 * @Date: 2023-06-02 10:17:52
 * @LastEditors: cchps neohua87@gmail.com
 * @LastEditTime: 2023-06-09 10:27:34
 * @FilePath: /vue-work/src/store/CounterModule.ts
 * @Description:
 *
 * Copyright (c) 2023 by skylar, All Rights Reserved.
 */
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import store from '@/store'

// export interface CounterInterface{
//     count:number;
//     increment:(delta:number)=>void,
//     decrement:(delta:number)=>void,
//     incr5:()=>void,
//     decr5:()=>void,
// }
export const COUNTER_NAME = 'counter'
// @Module({ name: 'counter', dynamic: true, namespaced: true, store: store })
// @Module({ name: 'counter', namespaced: true, dynamic: true, store: store })
// @Module({ generateMutationSetters: true })
@Module({ namespaced: true, name: COUNTER_NAME })
// export default class CounterModule extends VuexModule implements CounterInterface {
export default class CounterModule extends VuexModule {
  public count=0

  get halfCount () {
    return this.count / 2
  }

  get mcount () {
    return this.count
  }

  @Mutation
  increment (delta:number) {
    this.count += delta
  }

  @Mutation
  decrement (delta:number) {
    this.count -= delta
  }

  // action 'incr' commits mutation 'increment' when done with return value as payload
  @Action({ commit: 'increment' })
  incr5 () {
    return 5
    // this.context.commit('increment', 5)
  }

  // action 'decr' commits mutation 'decrement' when done with return value as payload
  @Action({ commit: 'decrement' })
  decr5 () {
    return 5
  }
}

// export const CounterModule = getModule(Counter)
